/**
 * Lista de países com seus respectivos nomes em português, códigos ISO 3166-1 alfa-2 e códigos de discagem internacional.
 *
 * @constant
 * @type {Array<{ name: string, code: string, dialCode: string, placeholder: string }>}
 * @property {string} name - Nome do país em português.
 * @property {string} code - Código ISO 3166-1 alfa-2 do país.
 * @property {string} dialCode - Código de discagem internacional do país (inclui o sinal de '').
 * @property {string} placeholder - Padrão de formato para números de telefone do país.
 * Esses dados foram obtidos da wikipedia: https://pt.wikipedia.org/wiki/Lista_de_c%C3%B3digos_telef%C3%B3nicos
 */

export const COUNTRY_DATA = [
  {
    name: 'Afeganistão',
    code: 'AF',
    dialCode: '93',
    placeholder: '12 345 6789'
  },
  { name: 'Albânia', code: 'AL', dialCode: '355', placeholder: '12 345 6789' },
  { name: 'Argélia', code: 'DZ', dialCode: '213', placeholder: '123 45 67 89' },
  { name: 'Andorra', code: 'AD', dialCode: '376', placeholder: '123 456' },
  { name: 'Angola', code: 'AO', dialCode: '244', placeholder: '123 456 789' },
  {
    name: 'Antígua e Barbuda',
    code: 'AG',
    dialCode: '1268',
    placeholder: '123 4567'
  },
  {
    name: 'Argentina',
    code: 'AR',
    dialCode: '54',
    placeholder: '12 3456 7890'
  },
  { name: 'Armênia', code: 'AM', dialCode: '374', placeholder: '12 345678' },
  { name: 'Aruba', code: 'AW', dialCode: '297', placeholder: '123 4567' },
  { name: 'Austrália', code: 'AU', dialCode: '61', placeholder: '123 456 789' },
  { name: 'Áustria', code: 'AT', dialCode: '43', placeholder: '123 456789' },
  {
    name: 'Azerbaijão',
    code: 'AZ',
    dialCode: '994',
    placeholder: '12 345 67 89'
  },
  { name: 'Bahamas', code: 'BS', dialCode: '1242', placeholder: '123 4567' },
  { name: 'Bahrein', code: 'BH', dialCode: '973', placeholder: '1234 5678' },
  {
    name: 'Bangladesh',
    code: 'BD',
    dialCode: '880',
    placeholder: '1234 567890'
  },
  { name: 'Barbados', code: 'BB', dialCode: '1246', placeholder: '123 4567' },
  {
    name: 'Bielorrússia',
    code: 'BY',
    dialCode: '375',
    placeholder: '12 345 67 89'
  },
  { name: 'Bélgica', code: 'BE', dialCode: '32', placeholder: '123 45 67 89' },
  { name: 'Belize', code: 'BZ', dialCode: '501', placeholder: '123 4567' },
  { name: 'Benin', code: 'BJ', dialCode: '229', placeholder: '12 34 56 78' },
  { name: 'Butão', code: 'BT', dialCode: '975', placeholder: '12 34 56 78' },
  { name: 'Bolívia', code: 'BO', dialCode: '591', placeholder: '1 234 5678' },
  {
    name: 'Bósnia e Herzegovina',
    code: 'BA',
    dialCode: '387',
    placeholder: '12 345 678'
  },
  { name: 'Botsuana', code: 'BW', dialCode: '267', placeholder: '12 345 678' },
  {
    name: 'Brasil',
    code: 'BR',
    dialCode: '55',
    placeholder: '(12) 34567-8901'
  },
  { name: 'Brunei', code: 'BN', dialCode: '673', placeholder: '123 4567' },
  { name: 'Bulgária', code: 'BG', dialCode: '359', placeholder: '123 456 789' },
  {
    name: 'Burkina Faso',
    code: 'BF',
    dialCode: '226',
    placeholder: '12 34 56 78'
  },
  { name: 'Burundi', code: 'BI', dialCode: '257', placeholder: '12 34 56 78' },
  { name: 'Camboja', code: 'KH', dialCode: '855', placeholder: '12 345 678' },
  {
    name: 'Camarões',
    code: 'CM',
    dialCode: '237',
    placeholder: '1 23 45 67 89'
  },
  { name: 'Canadá', code: 'CA', dialCode: '1', placeholder: '(123) 456-7890' },
  { name: 'Cabo Verde', code: 'CV', dialCode: '238', placeholder: '123 45 67' },
  {
    name: 'Ilhas Cayman',
    code: 'KY',
    dialCode: '1345',
    placeholder: '123 4567'
  },
  {
    name: 'República Centro-Africana',
    code: 'CF',
    dialCode: '236',
    placeholder: '12 34 56 78'
  },
  { name: 'Chade', code: 'TD', dialCode: '235', placeholder: '12 34 56 78' },
  { name: 'Chile', code: 'CL', dialCode: '56', placeholder: '1 2345 6789' },
  { name: 'China', code: 'CN', dialCode: '86', placeholder: '123 4567 8901' },
  { name: 'Colômbia', code: 'CO', dialCode: '57', placeholder: '123 456 7890' },
  { name: 'Comores', code: 'KM', dialCode: '269', placeholder: '123 45 67' },
  { name: 'Costa Rica', code: 'CR', dialCode: '506', placeholder: '1234 5678' },
  { name: 'Croácia', code: 'HR', dialCode: '385', placeholder: '12 345 6789' },
  { name: 'Cuba', code: 'CU', dialCode: '53', placeholder: '1 234 5678' },
  { name: 'Chipre', code: 'CY', dialCode: '357', placeholder: '12 345678' },
  {
    name: 'República Tcheca',
    code: 'CZ',
    dialCode: '420',
    placeholder: '123 456 789'
  },
  { name: 'Dinamarca', code: 'DK', dialCode: '45', placeholder: '12 34 56 78' },
  { name: 'Djibuti', code: 'DJ', dialCode: '253', placeholder: '12 34 56 78' },
  {
    name: 'República Dominicana',
    code: 'DO',
    dialCode: '1809',
    placeholder: '123 4567'
  },
  { name: 'Equador', code: 'EC', dialCode: '593', placeholder: '12 345 6789' },
  { name: 'Egito', code: 'EG', dialCode: '20', placeholder: '123 456 7890' },
  {
    name: 'El Salvador',
    code: 'SV',
    dialCode: '503',
    placeholder: '1234 5678'
  },
  {
    name: 'Guiné Equatorial',
    code: 'GQ',
    dialCode: '240',
    placeholder: '123 456 789'
  },
  { name: 'Estônia', code: 'EE', dialCode: '372', placeholder: '1234 5678' },
  { name: 'Etiópia', code: 'ET', dialCode: '251', placeholder: '12 345 6789' },
  { name: 'Ilhas Malvinas', code: 'FK', dialCode: '500', placeholder: '12345' },
  { name: 'Ilhas Faroe', code: 'FO', dialCode: '298', placeholder: '123456' },
  { name: 'Fiji', code: 'FJ', dialCode: '679', placeholder: '123 4567' },
  {
    name: 'Finlândia',
    code: 'FI',
    dialCode: '358',
    placeholder: '123 4567890'
  },
  { name: 'França', code: 'FR', dialCode: '33', placeholder: '1 23 45 67 89' },
  { name: 'Gabão', code: 'GA', dialCode: '241', placeholder: '1 23 45 67' },
  { name: 'Gâmbia', code: 'GM', dialCode: '220', placeholder: '123 4567' },
  { name: 'Geórgia', code: 'GE', dialCode: '995', placeholder: '123 45 67 89' },
  {
    name: 'Alemanha',
    code: 'DE',
    dialCode: '49',
    placeholder: '123 456789012'
  },
  { name: 'Gana', code: 'GH', dialCode: '233', placeholder: '12 345 6789' },
  { name: 'Grécia', code: 'GR', dialCode: '30', placeholder: '123 456 7890' },
  { name: 'Guatemala', code: 'GT', dialCode: '502', placeholder: '1234 5678' },
  { name: 'Guiné', code: 'GN', dialCode: '224', placeholder: '123 45 67 89' },
  { name: 'Guiana', code: 'GY', dialCode: '592', placeholder: '123 4567' },
  { name: 'Haiti', code: 'HT', dialCode: '509', placeholder: '1234 5678' },
  { name: 'Honduras', code: 'HN', dialCode: '504', placeholder: '1234 5678' },
  { name: 'Hong Kong', code: 'HK', dialCode: '852', placeholder: '1234 5678' },
  { name: 'Hungria', code: 'HU', dialCode: '36', placeholder: '12 345 6789' },
  { name: 'Islândia', code: 'IS', dialCode: '354', placeholder: '123 4567' },
  { name: 'Índia', code: 'IN', dialCode: '91', placeholder: '12345 67890' },
  {
    name: 'Indonésia',
    code: 'ID',
    dialCode: '62',
    placeholder: '123 456 7890'
  },
  { name: 'Irã', code: 'IR', dialCode: '98', placeholder: '123 456 7890' },
  { name: 'Iraque', code: 'IQ', dialCode: '964', placeholder: '123 456 7890' },
  { name: 'Irlanda', code: 'IE', dialCode: '353', placeholder: '123 456 7890' },
  { name: 'Israel', code: 'IL', dialCode: '972', placeholder: '12 345 6789' },
  { name: 'Itália', code: 'IT', dialCode: '39', placeholder: '123 456 7890' },
  { name: 'Jamaica', code: 'JM', dialCode: '1876', placeholder: '123 4567' },
  { name: 'Japão', code: 'JP', dialCode: '81', placeholder: '12 3456 7890' },
  { name: 'Jordânia', code: 'JO', dialCode: '962', placeholder: '1 2345 6789' },
  {
    name: 'Cazaquistão',
    code: 'KZ',
    dialCode: '7',
    placeholder: '123 456 7890'
  },
  { name: 'Quênia', code: 'KE', dialCode: '254', placeholder: '123 456789' },
  { name: 'Kuwait', code: 'KW', dialCode: '965', placeholder: '1234 5678' },
  {
    name: 'Quirguistão',
    code: 'KG',
    dialCode: '996',
    placeholder: '123 456789'
  },
  { name: 'Letônia', code: 'LV', dialCode: '371', placeholder: '12345678' },
  { name: 'Líbano', code: 'LB', dialCode: '961', placeholder: '12 345678' },
  { name: 'Lesoto', code: 'LS', dialCode: '266', placeholder: '1234 5678' },
  { name: 'Libéria', code: 'LR', dialCode: '231', placeholder: '123 456 789' },
  { name: 'Líbia', code: 'LY', dialCode: '218', placeholder: '12 345 6789' },
  {
    name: 'Liechtenstein',
    code: 'LI',
    dialCode: '423',
    placeholder: '123 456789'
  },
  { name: 'Lituânia', code: 'LT', dialCode: '370', placeholder: '(12) 345678' },
  {
    name: 'Luxemburgo',
    code: 'LU',
    dialCode: '352',
    placeholder: '123 456789'
  },
  { name: 'Macau', code: 'MO', dialCode: '853', placeholder: '1234 5678' },
  {
    name: 'Macedônia do Norte',
    code: 'MK',
    dialCode: '389',
    placeholder: '12 345 678'
  },
  {
    name: 'Madagáscar',
    code: 'MG',
    dialCode: '261',
    placeholder: '12 34 567 89'
  },
  { name: 'Malawi', code: 'MW', dialCode: '265', placeholder: '1234 56789' },
  { name: 'Malásia', code: 'MY', dialCode: '60', placeholder: '12 345 6789' },
  { name: 'Maldivas', code: 'MV', dialCode: '960', placeholder: '123 4567' },
  { name: 'Mali', code: 'ML', dialCode: '223', placeholder: '12 34 56 78' },
  { name: 'Malta', code: 'MT', dialCode: '356', placeholder: '1234 5678' },
  {
    name: 'Ilhas Marshall',
    code: 'MH',
    dialCode: '692',
    placeholder: '123 4567'
  },
  {
    name: 'Mauritânia',
    code: 'MR',
    dialCode: '222',
    placeholder: '12 34 56 78'
  },
  { name: 'Maurício', code: 'MU', dialCode: '230', placeholder: '1234 5678' },
  { name: 'México', code: 'MX', dialCode: '52', placeholder: '123 456 7890' },
  { name: 'Moldávia', code: 'MD', dialCode: '373', placeholder: '1234 5678' },
  { name: 'Mônaco', code: 'MC', dialCode: '377', placeholder: '1234 5678' },
  { name: 'Mongólia', code: 'MN', dialCode: '976', placeholder: '1234 5678' },
  {
    name: 'Montenegro',
    code: 'ME',
    dialCode: '382',
    placeholder: '12 345 678'
  },
  { name: 'Marrocos', code: 'MA', dialCode: '212', placeholder: '123 456789' },
  {
    name: 'Moçambique',
    code: 'MZ',
    dialCode: '258',
    placeholder: '12 345 6789'
  },
  { name: 'Mianmar', code: 'MM', dialCode: '95', placeholder: '1 234 5678' },
  { name: 'Namíbia', code: 'NA', dialCode: '264', placeholder: '12 345 6789' },
  { name: 'Nepal', code: 'NP', dialCode: '977', placeholder: '123 456 7890' },
  {
    name: 'Países Baixos',
    code: 'NL',
    dialCode: '31',
    placeholder: '12 345 6789'
  },
  {
    name: 'Nova Zelândia',
    code: 'NZ',
    dialCode: '64',
    placeholder: '123 456 789'
  },
  { name: 'Nicarágua', code: 'NI', dialCode: '505', placeholder: '1234 5678' },
  { name: 'Níger', code: 'NE', dialCode: '227', placeholder: '12 34 56 78' },
  { name: 'Nigéria', code: 'NG', dialCode: '234', placeholder: '123 456 7890' },
  {
    name: 'Coreia do Norte',
    code: 'KP',
    dialCode: '850',
    placeholder: '123 4567'
  },
  { name: 'Noruega', code: 'NO', dialCode: '47', placeholder: '123 45 678' },
  { name: 'Omã', code: 'OM', dialCode: '968', placeholder: '1234 5678' },
  { name: 'Paquistão', code: 'PK', dialCode: '92', placeholder: '123 4567890' },
  {
    name: 'Palestina',
    code: 'PS',
    dialCode: '970',
    placeholder: '123 456 789'
  },
  { name: 'Panamá', code: 'PA', dialCode: '507', placeholder: '1234 5678' },
  {
    name: 'Papua-Nova Guiné',
    code: 'PG',
    dialCode: '675',
    placeholder: '123 4567'
  },
  { name: 'Paraguai', code: 'PY', dialCode: '595', placeholder: '123 456789' },
  { name: 'Peru', code: 'PE', dialCode: '51', placeholder: '123 456 789' },
  {
    name: 'Filipinas',
    code: 'PH',
    dialCode: '63',
    placeholder: '123 456 7890'
  },
  { name: 'Polônia', code: 'PL', dialCode: '48', placeholder: '123 456 789' },
  { name: 'Portugal', code: 'PT', dialCode: '351', placeholder: '123 456 789' },
  { name: 'Catar', code: 'QA', dialCode: '974', placeholder: '1234 5678' },
  { name: 'Romênia', code: 'RO', dialCode: '40', placeholder: '123 456 789' },
  { name: 'Rússia', code: 'RU', dialCode: '7', placeholder: '123 456 7890' },
  { name: 'Ruanda', code: 'RW', dialCode: '250', placeholder: '123 456 789' },
  { name: 'Samoa', code: 'WS', dialCode: '685', placeholder: '12 3456' },
  {
    name: 'Arábia Saudita',
    code: 'SA',
    dialCode: '966',
    placeholder: '123 456 7890'
  },
  { name: 'Senegal', code: 'SN', dialCode: '221', placeholder: '12 345 67 89' },
  { name: 'Sérvia', code: 'RS', dialCode: '381', placeholder: '12 345 6789' },
  { name: 'Seichelles', code: 'SC', dialCode: '248', placeholder: '1 234 567' },
  { name: 'Singapura', code: 'SG', dialCode: '65', placeholder: '1234 5678' },
  {
    name: 'Eslováquia',
    code: 'SK',
    dialCode: '421',
    placeholder: '123 456 789'
  },
  { name: 'Eslovênia', code: 'SI', dialCode: '386', placeholder: '12 345 678' },
  { name: 'Somália', code: 'SO', dialCode: '252', placeholder: '12 345 678' },
  {
    name: 'África do Sul',
    code: 'ZA',
    dialCode: '27',
    placeholder: '12 345 6789'
  },
  {
    name: 'Sudão do Sul',
    code: 'SS',
    dialCode: '211',
    placeholder: '123 456 789'
  },
  {
    name: 'Coreia do Sul',
    code: 'KR',
    dialCode: '82',
    placeholder: '12 3456 7890'
  },
  { name: 'Espanha', code: 'ES', dialCode: '34', placeholder: '123 456 789' },
  { name: 'Sri Lanka', code: 'LK', dialCode: '94', placeholder: '12 345 6789' },
  { name: 'Sudão', code: 'SD', dialCode: '249', placeholder: '12 345 6789' },
  { name: 'Suriname', code: 'SR', dialCode: '597', placeholder: '123 4567' },
  { name: 'Suécia', code: 'SE', dialCode: '46', placeholder: '12 345 67 89' },
  { name: 'Suíça', code: 'CH', dialCode: '41', placeholder: '12 345 67 89' },
  { name: 'Síria', code: 'SY', dialCode: '963', placeholder: '12 345 6789' },
  { name: 'Taiwan', code: 'TW', dialCode: '886', placeholder: '123 456 789' },
  {
    name: 'Tadjiquistão',
    code: 'TJ',
    dialCode: '992',
    placeholder: '123 45 6789'
  },
  { name: 'Tanzânia', code: 'TZ', dialCode: '255', placeholder: '123 456 789' },
  { name: 'Tailândia', code: 'TH', dialCode: '66', placeholder: '12 345 6789' },
  {
    name: 'Timor-Leste',
    code: 'TL',
    dialCode: '670',
    placeholder: '1234 5678'
  },
  { name: 'Togo', code: 'TG', dialCode: '228', placeholder: '12 34 56 78' },
  { name: 'Tonga', code: 'TO', dialCode: '676', placeholder: '12345' },
  {
    name: 'Trinidad e Tobago',
    code: 'TT',
    dialCode: '1868',
    placeholder: '123 4567'
  },
  { name: 'Tunísia', code: 'TN', dialCode: '216', placeholder: '12 345 678' },
  { name: 'Turquia', code: 'TR', dialCode: '90', placeholder: '123 456 7890' },
  {
    name: 'Turcomenistão',
    code: 'TM',
    dialCode: '993',
    placeholder: '12 345678'
  },
  { name: 'Uganda', code: 'UG', dialCode: '256', placeholder: '123 456789' },
  { name: 'Ucrânia', code: 'UA', dialCode: '380', placeholder: '12 345 6789' },
  {
    name: 'Emirados Árabes Unidos',
    code: 'AE',
    dialCode: '971',
    placeholder: '12 345 6789'
  },
  {
    name: 'Reino Unido',
    code: 'GB',
    dialCode: '44',
    placeholder: '1234 567890'
  },
  {
    name: 'Estados Unidos',
    code: 'US',
    dialCode: '1',
    placeholder: '(123) 456-7890'
  },
  { name: 'Uruguai', code: 'UY', dialCode: '598', placeholder: '12 345 678' },
  {
    name: 'Uzbequistão',
    code: 'UZ',
    dialCode: '998',
    placeholder: '12 345 67 89'
  },
  {
    name: 'Venezuela',
    code: 'VE',
    dialCode: '58',
    placeholder: '123 456 7890'
  },
  { name: 'Vietnã', code: 'VN', dialCode: '84', placeholder: '12 3456 789' },
  { name: 'Iêmen', code: 'YE', dialCode: '967', placeholder: '123 456 789' },
  { name: 'Zâmbia', code: 'ZM', dialCode: '260', placeholder: '12 345 6789' },
  { name: 'Zimbábue', code: 'ZW', dialCode: '263', placeholder: '12 345 6789' }
];
